<template>
  <div class="PuntosListado">
    <md-table-card class="m-t-16">
      <md-toolbar>
        <h1 class="md-title">Puntos registrados</h1>
      </md-toolbar>
      <md-table class="tablita">
        <md-table-header>
          <md-table-row>
            <md-table-head>Punto</md-table-head>
            <md-table-head>Domicilio</md-table-head>
            <md-table-head>Cliente</md-table-head>
            <md-table-head>Acciones</md-table-head>
          </md-table-row>
        </md-table-header>
        <md-table-body>
          <md-table-row v-for="punto in puntos" :key="punto.punto">
            <md-table-cell>{{punto.nombre_pun}}</md-table-cell>
            <md-table-cell>{{punto.domicilio_pun}}</md-table-cell>
            <md-table-cell>{{punto.nombre_cli}}</md-table-cell>
            <md-table-cell>
              <div v-if="punto.pdf_pco != null">
                <md-button class="md-icon-button" @click.native="irAEditarPunto(punto.punto)">
                  <md-icon>edit</md-icon>
                  <md-tooltip md-direction="left">Editar punto</md-tooltip>
                </md-button>
                <md-button class="md-icon-button" @click.native="abrirModalEditarTurnos(punto)">
                  <md-icon>access_time</md-icon>
                  <md-tooltip md-direction="left">Editar turnos</md-tooltip>
                </md-button>
                <md-button class="md-icon-button" @click.native="abrirModalAgregarTurnos(punto)">
                  <md-icon>add</md-icon>
                  <md-tooltip md-direction="left">Agregar turnos</md-tooltip>
                </md-button>
                <md-button class="md-icon-button" @click.native="abrirModalSeleccionarTurno(punto.punto)">
                  <md-icon>today</md-icon>
                  <md-tooltip md-direction="left">Editar roles</md-tooltip>
                </md-button>
                <md-button class="md-icon-button" @click.native="abrirModalEdicionContratos(punto)">
                  <md-icon>description</md-icon>
                  <md-tooltip md-direction="left">Contratos</md-tooltip>
                </md-button>
              </div>
              <div v-else>
                <md-button class="md-raised md-icon-button md-warn" @click.native="abrirModalSubirContrato(punto)">
                  <md-icon>description</md-icon>
                  <md-tooltip md-direction="left">Subir contrato firmado</md-tooltip>
                </md-button>
              </div>
            </md-table-cell>
          </md-table-row>
        </md-table-body>
      </md-table>
    </md-table-card>
    <md-dialog md-open-from="#custom" md-close-to="#custom" ref="modalEditarTurnos">
      <md-dialog-title>{{punto.nombre_pun}}</md-dialog-title>
      <md-dialog-content>
        <md-list class="md-double-line" v-for="t in turnosPunto" :key="t.id_ptu">
          <md-list-item>
            <div class="md-list-text-container">
              <span>{{moment(t.inicio_ptu,'h:mm:ss').format('h:mm A')}} a {{moment(t.termino_ptu,'h:mm:ss').format('h:mm A')}} </span>
              <span>{{t.estatus_ptu.toUpperCase()}}</span>
            </div>
            <md-button class="md-icon-button md-list-action md-primary">
              <md-icon class="md-primary" @click.native="cambiarEstatusTurno(t.id_ptu,'activo')" v-if="t.estatus_ptu != 'activo'">play_arrow</md-icon>
              <md-icon class="md-primary" @click.native="cambiarEstatusTurno(t.id_ptu,'inactivo')" v-else>pause</md-icon>
            </md-button>
          </md-list-item>
        </md-list>
      </md-dialog-content>
      <md-dialog-actions>
        <md-button @click.native="cerrarModalEditarTurnos()">Cerrar</md-button>
      </md-dialog-actions>
    </md-dialog>
    <md-dialog md-open-from="#custom" md-close-to="#custom" ref="modalAgregarTurnos">
      <md-dialog-title>{{punto.nombre_pun}}</md-dialog-title>
      <md-dialog-content>
        <md-layout md-flex="100" md-gutter="24">
          <md-layout>
            <md-input-container v-bind:class="{ 'md-input-invalid': val.v_inicio_tur }">
              <label for="inicio_tur">Inicio</label>
              <md-select name="inicio_tur" id="inicio_tur" v-model="turno.inicio_ptu">
                <md-option value="1 AM">1 AM</md-option>
                <md-option value="2 AM">2 AM</md-option>
                <md-option value="3 AM">3 AM</md-option>
                <md-option value="4 AM">4 AM</md-option>
                <md-option value="5 AM">5 AM</md-option>
                <md-option value="6 AM">6 AM</md-option>
                <md-option value="7 AM">7 AM</md-option>
                <md-option value="8 AM">8 AM</md-option>
                <md-option value="9 AM">9 AM</md-option>
                <md-option value="10 AM">10 AM</md-option>
                <md-option value="11 AM">11 AM</md-option>
                <md-option value="12 AM">12 AM</md-option>
                <md-option value="1 PM">1 PM</md-option>
                <md-option value="2 PM">2 PM</md-option>
                <md-option value="3 PM">3 PM</md-option>
                <md-option value="4 PM">4 PM</md-option>
                <md-option value="5 PM">5 PM</md-option>
                <md-option value="6 PM">6 PM</md-option>
                <md-option value="7 PM">7 PM</md-option>
                <md-option value="8 PM">8 PM</md-option>
                <md-option value="9 PM">9 PM</md-option>
                <md-option value="10 PM">10 PM</md-option>
                <md-option value="11 PM">11 PM</md-option>
                <md-option value="12 PM">12 PM</md-option>
              </md-select>
            </md-input-container>
          </md-layout>
          <md-layout>
            <md-input-container v-bind:class="{ 'md-input-invalid': val.v_fin_tur }">
              <label for="fin_tur">Fin</label>
              <md-select name="fin_tur" id="fin_tur" v-model="turno.termino_ptu">
                <md-option value="1 AM">1 AM</md-option>
                <md-option value="2 AM">2 AM</md-option>
                <md-option value="3 AM">3 AM</md-option>
                <md-option value="4 AM">4 AM</md-option>
                <md-option value="5 AM">5 AM</md-option>
                <md-option value="6 AM">6 AM</md-option>
                <md-option value="7 AM">7 AM</md-option>
                <md-option value="8 AM">8 AM</md-option>
                <md-option value="9 AM">9 AM</md-option>
                <md-option value="10 AM">10 AM</md-option>
                <md-option value="11 AM">11 AM</md-option>
                <md-option value="12 AM">12 AM</md-option>
                <md-option value="1 PM">1 PM</md-option>
                <md-option value="2 PM">2 PM</md-option>
                <md-option value="3 PM">3 PM</md-option>
                <md-option value="4 PM">4 PM</md-option>
                <md-option value="5 PM">5 PM</md-option>
                <md-option value="6 PM">6 PM</md-option>
                <md-option value="7 PM">7 PM</md-option>
                <md-option value="8 PM">8 PM</md-option>
                <md-option value="9 PM">9 PM</md-option>
                <md-option value="10 PM">10 PM</md-option>
                <md-option value="11 PM">11 PM</md-option>
                <md-option value="12 PM">12 PM</md-option>
              </md-select>
            </md-input-container>
          </md-layout>
          <md-layout>
            <md-button class="md-icon-button md-raised md-accent" @click.native="agregarTurno()">
              <md-icon>add</md-icon>
            </md-button>
          </md-layout>
        </md-layout>
        <md-layout md-flex="100" md-align="center">
          <md-list class="md-double-line" v-for="tn in turnosNuevos" :key="tn.id_ptu">
            <md-list-item>
              <div class="md-list-text-container">
                <span>{{tn.inicio_ptu}} a {{tn.termino_ptu}}</span>
              </div>
              <md-button class="md-icon-button md-list-action md-primary">
                <md-icon @click.native="removerTurnoNuevo(tn)">delete</md-icon>
              </md-button>
            </md-list-item>
          </md-list>
        </md-layout>
      </md-dialog-content>
      <md-dialog-actions>
        <md-button @click.native="cerrarModalAgregarTurnos()">Cancelar</md-button>
        <md-button class="md-raised md-primary" @click.native="guardarTurnos()">Guardar turnos</md-button>
      </md-dialog-actions>
    </md-dialog>
    <md-dialog md-open-from="#custom" md-close-to="#custom" ref="modalSeleccionarTurno">
      <md-dialog-title>VER ROLES DEL PUNTO</md-dialog-title>
      <md-dialog-content>
        <md-list class="md-double-line" v-for="t in turnosPunto" :key="t.id_ptu">
          <md-list-item>
            <div class="md-list-text-container">
              <span>{{moment(t.inicio_ptu,'h:mm:ss').format('h:mm A')}} a {{moment(t.termino_ptu,'h:mm:ss').format('h:mm A')}}</span>
              <span>{{t.estatus_ptu.toUpperCase()}}</span>
            </div>
            <md-button class="md-icon-button md-list-action md-primary">
              <md-icon class="md-primary" @click.native="irEditarRolesTurno(t.id_ptu)">edit</md-icon>
            </md-button>
          </md-list-item>
        </md-list>
      </md-dialog-content>
      <md-dialog-actions>
        <md-button @click.native="cerrarModalSeleccionarTurno()">Cerrar</md-button>
      </md-dialog-actions>
    </md-dialog>
    <md-dialog md-open-from="#custom" md-close-to="#custom" ref="modalSubirContrato">
      <md-dialog-title>PUNTO {{punto.nombre_pun}}</md-dialog-title>
      <md-dialog-content>
        <div class="md-subheading">CONTRATO {{punto.titulo_cnt}}<br><br></div>
        <md-button class="md-raised md-accent" @click.native="abrirVentanaGenerarContrato(punto.punto)">Generar contrato en PDF</md-button>
        <md-input-container>
          <label>Subir contrato firmado</label>
          <md-file v-model="single" accept="application/pdf" @selected="prepararContratoSubir($event)"></md-file>
        </md-input-container>
      </md-dialog-content>
      <md-dialog-actions>
        <md-button @click.native="cerrarModal('modalSubirContrato')">Cerrar</md-button>
        <md-button class="md-raised md-primary" @click.native="guardarArchivoContrato()" v-if="archivo_contrato != null">Subir contrato</md-button>
      </md-dialog-actions>
    </md-dialog>
    <md-dialog md-open-from="#custom" md-close-to="#custom" ref="modalEdicionContratos">
      <md-dialog-title>PUNTO {{punto.nombre_pun}}</md-dialog-title>
      <table class="md-table md-theme-default">
        <md-table-header>
          <md-table-row>
            <md-table-head>Contrato</md-table-head>
            <md-table-head>Desde</md-table-head>
            <md-table-head>Hasta</md-table-head>
            <md-table-head>Acciones</md-table-head>
          </md-table-row>
        </md-table-header>
        <md-table-body>
          <md-table-row v-for="pco in contratos_punto" :key="pco.id_cnt_pco">
            <md-table-cell>{{pco.titulo_cnt}}</md-table-cell>
            <md-table-cell>{{moment(pco.desde_pco,'YYYY-MM-DD h:mm:ss').format('YYYY-MM-DD h:mm A')}}</md-table-cell>
            <md-table-cell>
              <div v-if="pco.hasta_pco"> {{moment(pco.hasta_pco,'YYYY-MM-DD h:mm:ss').format('YYYY-MM-DD h:mm A')}} </div>
              <div v-else>
                ACTIVO
              </div>
            </md-table-cell>
            <md-table-cell>
              <div v-if="pco.hasta_pco === null">
                <md-button class="md-raised md-warn" style="width:auto" @click.native="suspenderContrato(pco.id_pun_pco,pco.id_cnt_pco)">
                  Suspender
                </md-button>
              </div>
            </md-table-cell>
          </md-table-row>
        </md-table-body>
      </table>
      <md-dialog-content class="m-t-24">
        <div class="md-subheading">¿Desea cambiar el tipo de contrato?</div>
        <md-input-container v-bind:class="{ 'md-input-invalid': val.v_id_cnt }">
          <label for="id_cnt_pun">Contrato</label>
          <md-select name="id_cnt_pun" id="id_cnt_pun" v-model="contrato_nuevo" required>
            <md-option v-for="cnt in contratos" :value="cnt.id_cnt" :key="cnt.id_cnt">
              {{ cnt.titulo_cnt }}
            </md-option>
          </md-select>
        </md-input-container>
      </md-dialog-content>
      <md-dialog-actions>
        <md-button @click.native="cerrarModal('modalEdicionContratos')">Cerrar</md-button>
        <md-button class="md-raised md-primary" @click.native="anadirContrato(punto.id_pun)" v-if="contrato_nuevo!=null">Cambiar contrato</md-button>
      </md-dialog-actions>
    </md-dialog>
    <md-dialog md-open-from="#custom" md-close-to="#custom" ref="subiendoArchivo" :md-click-outside-to-close="false" :md-esc-to-close="false">
      <md-progress md-indeterminate></md-progress>
    </md-dialog>
  </div>
</template>
<script>
import sha1 from "js-sha1";
import md5 from "blueimp-md5";
import Snackbar from "node-snackbar";
import $ from "jquery";
import dt from "datatables.net";
import moment from "moment";
export default {
  name: "PuntosListado",
  methods: {
    moment(a, b) {
      return moment(a, b);
    },
    obtenerPuntos() {
      this.$http
        .post("puntos", {
          token: this.$session.get("token"),
          estatus: "activos"
        })
        .then(
          response => {
            if (response.status === 200 && "puntos" in response.body) {
              this.puntos = response.body.puntos;
            }
          },
          response => {
            Snackbar.show({
              text: "No se pudo establecer conexión con el servidor.",
              actionText: "Cerrar",
              pos: "top-right",
              showAction: false,
              backgroundColor: "#F44336",
              actionTextColor: "#FFF"
            });
          }
        );
    },
    obtenerContratos() {
      this.$http
        .post("contratos", {
          token: this.$session.get("token"),
          tipo: "servicios_guardias"
        })
        .then(
          response => {
            if (response.status === 200 && "contratos" in response.body) {
              this.contratos = response.body.contratos;
            } else {
              /*
              Snackbar.show({ text: response.body.error, actionText: "Cerrar", showAction: false, pos: "top-right", backgroundColor: "#F44336", actionTextColor: "#FFF" });
              */
            }
          },
          response => {
            /*
            Snackbar.show({ text: "No se pudo establecer conexión con el servidor para obtener los contratos.", actionText: "Cerrar", showAction: false, pos: "top-right", backgroundColor: "#F44336", actionTextColor: "#FFF" });
            */
          }
        );
    },
    abrirModalEditarTurnos(punto) {
      this.punto = punto;
      this.obtenerTurnosPunto(punto.punto);
      this.abrirModal("modalEditarTurnos");
    },
    cerrarModalEditarTurnos() {
      this.cerrarModal("modalEditarTurnos");
      this.turnosPunto = null;
      this.punto = null;
    },
    abrirModalAgregarTurnos(punto) {
      this.punto = punto;
      this.abrirModal("modalAgregarTurnos");
    },
    cerrarModalAgregarTurnos(punto) {
      this.cerrarModal("modalAgregarTurnos");
      this.punto = null;
    },
    abrirModalSeleccionarTurno(punto) {
      this.punto = punto;
      this.obtenerTurnosPunto(punto);
      this.abrirModal("modalSeleccionarTurno");
    },
    cerrarModalSeleccionarTurno() {
      this.turnosPunto = null;
      this.punto = null;
      this.cerrarModal("modalSeleccionarTurno");
    },
    //MANEJO DE CONTRATOS
    abrirModalSubirContrato(punto) {
      this.punto = punto;
      this.abrirModal("modalSubirContrato");
    },
    abrirVentanaGenerarContrato(ep) {
      window.open(
        "http://api.grupoalarcom.mx/contratos/pdf?a=p&n=" + ep,
        "_blank"
      );
    },
    guardarArchivoContrato() {
      if (this.hayContratoAnexado()) {
        this.cerrarModal("modalSubirContrato");
        this.abrirModal("subiendoArchivo");
        var formData = new FormData();
        formData.append("token", this.$session.get("token"));
        formData.append("punto", this.punto.punto);
        formData.append("archivo", this.archivo_contrato);
        this.$http.post("puntos/subirContrato", formData).then(
          response => {
            if (response.status === 200 && "msg" in response.body) {
              Snackbar.show({
                text: response.body.msg,
                pos: "top-right",
                actionText: "Cerrar",
                showAction: false,
                duration: 20000
              });
            } else {
              Snackbar.show({
                text: response.body.error,
                actionText: "Cerrar",
                pos: "top-right",
                showAction: false,
                backgroundColor: "#CC3D30",
                actionTextColor: "#FFF"
              });
            }
            this.cerrarModal("subiendoArchivo");
            this.obtenerPuntos();
          },
          response => {
            Snackbar.show({
              text:
                "No se pudo establecer conexión con el servidor. Inténtelo de nuevo.",
              actionText: "Cerrar",
              pos: "top-right",
              showAction: false,
              backgroundColor: "#CC3D30",
              actionTextColor: "#FFF"
            });
            this.cerrarModal("subiendoArchivo");
            this.obtenerPuntos();
          }
        );
      }
    },
    prepararContratoSubir(e) {
      this.archivo_contrato = e[0];
    },
    hayContratoAnexado() {
      if (this.archivo_contrato) {
        return true;
      } else {
        Snackbar.show({
          text: "Debe seleccionar el archivo de su investigación",
          actionText: "Cerrar",
          showAction: false,
          pos: "top-right",
          duration: 10000,
          backgroundColor: "#CC3D30",
          actionTextColor: "#FFF"
        });
        return false;
      }
    },
    abrirModalEdicionContratos(punto) {
      this.punto = punto;
      this.obtenerContratosPunto(punto.punto);
      this.abrirModal("modalEdicionContratos");
    },
    suspenderContrato(p, c) {
      this.$http
        .post("contratos/suspenderDePunto", {
          token: this.$session.get("token"),
          punto: sha1(md5(p)),
          contrato: sha1(md5(c))
        })
        .then(
          response => {
            if (response.status === 200 && "msg" in response.body) {
              Snackbar.show({
                text: response.body.msg,
                actionText: "Cerrar",
                showAction: false,
                pos: "top-right"
              });
              this.obtenerContratosPunto(sha1(md5(p)));
            } else {
              Snackbar.show({
                text: response.body.error,
                actionText: "Cerrar",
                showAction: false,
                pos: "top-right",
                backgroundColor: "#F44336",
                actionTextColor: "#FFF"
              });
            }
          },
          response => {
            Snackbar.show({
              text:
                "No se pudo establecer conexión con el servidor para suspender los contratos.",
              actionText: "Cerrar",
              showAction: false,
              pos: "top-right",
              backgroundColor: "#F44336",
              actionTextColor: "#FFF"
            });
          }
        );
    },
    anadirContrato(p) {
      this.$http
        .post("contratos/anadirContrato", {
          token: this.$session.get("token"),
          punto: p,
          contrato: this.contrato_nuevo
        })
        .then(
          response => {
            if (response.status === 200 && "msg" in response.body) {
              Snackbar.show({
                text: response.body.msg,
                actionText: "Cerrar",
                showAction: false,
                pos: "top-right"
              });
              this.cerrarModal("modalEdicionContratos");
              this.contrato_nuevo = null;
              this.obtenerPuntos();
            } else {
              Snackbar.show({
                text: response.body.error,
                actionText: "Cerrar",
                showAction: false,
                pos: "top-right",
                backgroundColor: "#F44336",
                actionTextColor: "#FFF"
              });
            }
          },
          response => {
            Snackbar.show({
              text:
                "No se pudo establecer conexión con el servidor para agregar contratos al punto.",
              actionText: "Cerrar",
              showAction: false,
              pos: "top-right",
              backgroundColor: "#F44336",
              actionTextColor: "#FFF"
            });
          }
        );
    },
    obtenerContratosPunto(id_pun) {
      this.$http
        .post("contratos/punto", {
          token: this.$session.get("token"),
          punto: id_pun
        })
        .then(
          response => {
            if (response.status === 200 && "contratos" in response.body) {
              this.contratos_punto = response.body.contratos;
            } else {
              Snackbar.show({
                text: response.body.error,
                actionText: "Cerrar",
                showAction: false,
                pos: "top-right",
                backgroundColor: "#F44336",
                actionTextColor: "#FFF"
              });
            }
          },
          response => {
            Snackbar.show({
              text:
                "No se pudo establecer conexión con el servidor para obtener los contratos del punto.",
              actionText: "Cerrar",
              showAction: false,
              pos: "top-right",
              backgroundColor: "#F44336",
              actionTextColor: "#FFF"
            });
          }
        );
    },
    //FIN MANEJO DE CONTRATOS
    agregarTurno() {
      if (this.validarSelectsTurno()) {
        this.turnosNuevos.push({
          inicio_ptu: this.turno.inicio_ptu,
          termino_ptu: this.turno.termino_ptu
        });
        this.turno.inicio_ptu = null;
        this.turno.termino_ptu = null;
        this.val.v_inicio_tur = null;
        this.val.v_fin_tur = null;
      }
    },
    existenTurnosRegistrados() {
      if (this.turnosNuevos.length > 0) {
        return true;
      } else {
        Snackbar.show({
          text: "Debe agregar por lo menos un turno",
          actionText: "Cerrar",
          showAction: false,
          pos: "top-right",
          duration: 10000,
          backgroundColor: "#CC3D30",
          actionTextColor: "#FFF"
        });
        return false;
      }
    },
    validarSelectsTurno() {
      !this.turno.inicio_ptu
        ? (this.val.v_inicio_tur = true)
        : (this.val.v_inicio_tur = false);
      !this.turno.termino_ptu
        ? (this.val.v_fin_tur = true)
        : (this.val.v_fin_tur = false);
      if (this.val.v_fin_tur || this.val.v_inicio_tur) {
        Snackbar.show({
          text: "Por favor seleccione los horarios del turno",
          actionText: "Cerrar",
          showAction: false,
          pos: "top-right",
          duration: 10000,
          backgroundColor: "#CC3D30",
          actionTextColor: "#FFF"
        });
        return false;
      } else {
        return true;
      }
    },
    guardarTurnos() {
      if (this.existenTurnosRegistrados()) {
        this.$http
          .post("turnos/guardar", {
            token: this.$session.get("token"),
            punto: this.punto.id_pun,
            turnos: this.turnosNuevos
          })
          .then(
            response => {
              if (response.status === 200 && "msg" in response.body) {
                Snackbar.show({
                  text: response.body.msg,
                  actionText: "Cerrar",
                  showAction: false,
                  pos: "top-right"
                });
                this.$refs["modalAgregarTurnos"].close();
                this.punto = null;
              } else {
                Snackbar.show({
                  text: response.body.error,
                  actionText: "Cerrar",
                  showAction: false,
                  pos: "top-right",
                  backgroundColor: "#F44336",
                  actionTextColor: "#FFF"
                });
              }
            },
            response => {
              Snackbar.show({
                text: "No se pudo establecer conexión con el servidor.",
                actionText: "Cerrar",
                showAction: false,
                pos: "top-right",
                backgroundColor: "#F44336",
                actionTextColor: "#FFF"
              });
            }
          );
      }
    },
    obtenerTurnosPunto(id) {
      this.$http
        .post("puntos/turnos", {
          token: this.$session.get("token"),
          id: id
        })
        .then(
          response => {
            if (response.status === 200 && "turnos" in response.body) {
              this.turnosPunto = response.body.turnos;
            }
          },
          response => {
            Snackbar.show({
              text: "No se pudo establecer conexión con el servidor.",
              actionText: "Cerrar",
              pos: "top-right",
              showAction: false,
              backgroundColor: "#F44336",
              actionTextColor: "#FFF"
            });
          }
        );
    },
    removerTurnoNuevo(index) {
      this.turnosNuevos.splice(index, 1);
    },
    cambiarEstatusTurno(turno, estatus) {
      this.$http
        .post("turnos/estatus", {
          token: this.$session.get("token"),
          turno: turno,
          estatus: estatus
        })
        .then(
          response => {
            if (response.status === 200 && "msg" in response.body) {
              Snackbar.show({
                text: response.body.msg,
                actionText: "Cerrar",
                showAction: false,
                pos: "top-right"
              });
              this.obtenerTurnosPunto(this.punto.punto);
            } else {
              Snackbar.show({
                text: response.body.error,
                actionText: "Cerrar",
                showAction: false,
                pos: "top-right",
                backgroundColor: "#F44336",
                actionTextColor: "#FFF"
              });
            }
          },
          response => {
            Snackbar.show({
              text: "No se pudo establecer conexión con el servidor.",
              actionText: "Cerrar",
              showAction: false,
              pos: "top-right",
              backgroundColor: "#F44336",
              actionTextColor: "#FFF"
            });
          }
        );
    },
    irAEditarPunto(id) {
      this.$router.push({ name: "PuntosEditar", params: { punto: id } });
    },
    irEditarRolesTurno(id) {
      this.$router.push({
        name: "PuntosRoles",
        params: { turno: sha1(md5(id)) }
      });
    },
    abrirModal(ref) {
      this.$refs[ref].open();
    },
    cerrarModal(ref) {
      this.$refs[ref].close();
    }
  },
  beforeCreate: function() {
    if (!this.$session.exists()) {
      this.$router.push("/login");
    }
  },
  beforeMount() {
    this.obtenerPuntos();
    this.obtenerContratos();
  },
  updated() {
    $(".md-table.tablita > table").DataTable();
  },
  data() {
    return {
      editar: this.$parent.permisos_editar_nomina,
      single: null,
      puntos: [],
      contratos: [],
      contratos_punto: [],
      contrato_nuevo: null,
      punto: {},
      turnosPunto: [],
      turno: {
        inicio_ptu: null,
        termino_ptu: null
      },
      turnosNuevos: [],
      archivo_contrato: null,
      val: {
        v_inicio_tur: null,
        v_fin_tur: null
      }
    };
  }
};
</script>


// WEBPACK FOOTER //
// PuntosListado.vue?ea0a2250